/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Verify_RequiredInputs */

const en_settings_verify_required = /** @type {(inputs: Settings_Verify_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`University verification required`)
};

const de_settings_verify_required = /** @type {(inputs: Settings_Verify_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universitätsverifizierung erforderlich`)
};

const fr_settings_verify_required = /** @type {(inputs: Settings_Verify_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérification universitaire requise`)
};

const es_settings_verify_required = /** @type {(inputs: Settings_Verify_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificación universitaria requerida`)
};

const it_settings_verify_required = /** @type {(inputs: Settings_Verify_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica universitaria richiesta`)
};

const nl_settings_verify_required = /** @type {(inputs: Settings_Verify_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificatie van de universiteit vereist`)
};

const pl_settings_verify_required = /** @type {(inputs: Settings_Verify_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wymagana weryfikacja przez uczelnię`)
};

const fi_settings_verify_required = /** @type {(inputs: Settings_Verify_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yliopiston varmistus vaaditaan`)
};

const da_settings_verify_required = /** @type {(inputs: Settings_Verify_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universitetsverifikation påkrævet`)
};

const sv_settings_verify_required = /** @type {(inputs: Settings_Verify_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universitetsverifiering krävs`)
};

/**
* | output |
* | --- |
* | "University verification required" |
*
* @param {Settings_Verify_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_verify_required = /** @type {((inputs?: Settings_Verify_RequiredInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Verify_RequiredInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_verify_required(inputs)
	if (locale === "fr") return fr_settings_verify_required(inputs)
	if (locale === "es") return es_settings_verify_required(inputs)
	if (locale === "it") return it_settings_verify_required(inputs)
	if (locale === "nl") return nl_settings_verify_required(inputs)
	if (locale === "pl") return pl_settings_verify_required(inputs)
	if (locale === "fi") return fi_settings_verify_required(inputs)
	if (locale === "da") return da_settings_verify_required(inputs)
	if (locale === "sv") return sv_settings_verify_required(inputs)
	return en_settings_verify_required(inputs)
});